import React from "react";
import logo from "../img/logo.svg";
export default function Footer() {
  return (
    <footer>
      <div className="footercontainer">
        <p>
          Bærehjelp er levert av Infinitum som et lavterskeltilbud for deg som
          møter utfordringer med å pante flasker eller bokser.
        </p>
        <a href="https://infinitum.no/">
          <img src={logo} className="logo" alt="Infinitum logo" />
        </a>
      </div>
    </footer>
  );
}
